import { fallbackWheelCardConfig } from './fallbackConfig'

export enum WHEEL_MODES {
  default = 'default',
  halloween = 'halloween',
  christmas = 'christmas',
  saint_valentine = 'saint_valentine',
  easter = 'easter',
  summer = 'summer',
  summer_spinner = 'summer_spinner',
  weekend_super_spinner = 'weekend_super_spinner',
  loyalty_legend = 'loyalty_legend',
  loyalty_icon = 'loyalty_icon',
  star_spangled = 'star_spangled',
}

export const isLoyaltyMode = (mode: WHEEL_MODES) => {
  return mode === WHEEL_MODES.loyalty_legend || mode === WHEEL_MODES.loyalty_icon
}

// Export fallback config as default for backward compatibility
export default fallbackWheelCardConfig
